import enterpriseClient from "./enterpriseClient";

/**
 * Fetch list of enterprise companies.
 * Endpoint: GET /api/v2/company/company-list
 *
 * @returns {Promise<any>} Company list response data
 */
export const getEnterpriseCompanyListAPI = async () => {
  try {
    const response = await enterpriseClient.get("/api/v2/company/company-list");
    return response.data;
  } catch (error) {
    console.error("Error fetching enterprise company list:", error);
    return Promise.reject(error?.response?.data || error);
  }
};

/**
 * Alias with original casing for backward compatibility
 */
export const GetEnterPriseCompanyListAPI = getEnterpriseCompanyListAPI;

export default getEnterpriseCompanyListAPI;
